import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SolutionFinderService {
  restartFinder: BehaviorSubject<boolean> = new BehaviorSubject(false);
  closeFinder: BehaviorSubject<string> = new BehaviorSubject('complete');
  closeInlineSearch: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  closeModal() {
    this.restartFinder.next(true);
    this.closeFinder.next('updating');
  }
}
